module.exports = __webpack_public_path__ + "img/document-icon.6afb8ca.png";